module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.platform.name),
      expression: "platform.name"
    }],
    class: {
      'input': true,
      'is-disabled': true
    },
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.platform.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.platform, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4),
      expression: "parseInt(context.$store.state.config.user.level) < 4"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Booking Fee")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.platform.booking_fee_type),
      expression: "platform.booking_fee_type"
    }],
    staticClass: "select",
    attrs: {
      "name": "booking_fee_type",
      "id": "booking_fee_type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.platform, "booking_fee_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Value")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.platform.booking_fee_value),
      expression: "platform.booking_fee_value"
    }],
    class: {
      'input': true,
      'is-disabled': parseInt(_vm.platform.booking_fee_type) !== 0 ? false : true
    },
    staticStyle: {
      "width": "4rem",
      "vertical-align": "middle"
    },
    attrs: {
      "type": "text",
      "name": "booking_fee_value",
      "id": "booking_fee_value"
    },
    domProps: {
      "value": (_vm.platform.booking_fee_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.platform, "booking_fee_value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-loading': _vm.inProgress,
      'is-disabled': _vm.errors.any()
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11fd55f0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/customer/Platform.vue
// module id = 1071
// module chunks = 39